/* Search drawer bestsellers — available products from best-sellers collection */

(function () {
  'use strict';

  if (window.__BM_SEARCH_BESTSELLERS__) return;
  window.__BM_SEARCH_BESTSELLERS__ = true;

  var COLLECTION_HANDLE = 'best-sellers';
  var COLLECTION_URL = '/collections/best-sellers';
  var LIMIT = 4;
  var FETCH_LIMIT = 50;
  var HEADING = "We couldn't find that - browse our bestsellers";
  var DONE_ATTR = 'data-ig-bestsellers-done';

  function formatMoney(price) {
    var n = parseFloat(price, 10);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(n);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function productUrl(product) {
    return '/products/' + product.handle;
  }

  function firstAvailableVariant(product) {
    var variants = (product && product.variants) || [];
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i] && variants[i].available === true) return variants[i];
    }
    return null;
  }

  function isAvailable(product) {
    return !!firstAvailableVariant(product);
  }

  function productImage(product) {
    if (product.images && product.images.length && product.images[0].src) {
      return product.images[0].src;
    }
    return '';
  }

  function renderItem(product) {
    var href = productUrl(product);
    var title = escapeHtml(product.title || '');
    var img = productImage(product);
    var variant = firstAvailableVariant(product) || {};
    var price = formatMoney(variant.price);
    var compare = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
    var priceHtml = '';

    if (price) {
      if (compare && parseFloat(variant.compare_at_price, 10) > parseFloat(variant.price, 10)) {
        priceHtml =
          '<div class="price">' +
          '<s>' + escapeHtml(compare) + '</s> ' +
          '<span>' + escapeHtml(price) + '</span>' +
          '</div>';
      } else {
        priceHtml = '<div class="price"><span>' + escapeHtml(price) + '</span></div>';
      }
    }

    var mediaHtml = img
      ? '<a href="' + href + '" class="media-wrapper blocks-radius-sm">' +
        '<img src="' + img + '" alt="' + title + '" width="100" height="100" loading="lazy">' +
        '</a>'
      : '';

    return (
      '<li class="predictive-search__list-item">' +
      '<div class="flex items-center gap-3">' +
      mediaHtml +
      '<div class="grid gap-1">' +
      '<p class="block m-0">' +
      '<a href="' + href + '" class="reversed-link text-pcard-title">' + title + '</a>' +
      '</p>' +
      priceHtml +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  function updateBlock(block, products) {
    if (!block || block.getAttribute(DONE_ATTR) === '1') return;

    block.classList.add('ig-bestsellers-rec');

    var heading = block.querySelector('h4.h5');
    if (heading) heading.textContent = HEADING;

    var list = block.querySelector('ul.grid');
    if (list && products && products.length) {
      list.innerHTML = products.map(renderItem).join('');
    }

    if (!block.querySelector('.ig-bestsellers-link')) {
      var link = document.createElement('a');
      link.className = 'ig-bestsellers-link reversed-link';
      link.href = COLLECTION_URL;
      link.textContent = 'Shop Best Sellers';
      block.appendChild(link);
    }

    block.setAttribute(DONE_ATTR, '1');
  }

  function enhance() {
    var blocks = document.querySelectorAll('.search__products-recommendation');
    if (!blocks.length) return;

    var pending = [];
    blocks.forEach(function (block) {
      if (block.getAttribute(DONE_ATTR) !== '1') pending.push(block);
    });
    if (!pending.length) return;

    fetch('/collections/' + COLLECTION_HANDLE + '/products.json?limit=' + FETCH_LIMIT, {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('fetch failed');
        return res.json();
      })
      .then(function (data) {
        var products = ((data && data.products) || []).filter(isAvailable).slice(0, LIMIT);
        pending.forEach(function (block) {
          updateBlock(block, products);
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  var obs = new MutationObserver(function () {
    enhance();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
